import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/footer/Footer";
import Header from "../components/navbar/Header";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import serviceBanner from "../assets/mobile-banners/Gem_Web_Banners_Contact.webp";
import CustomSlider from "../components/CustomSlider";
const servicemobileSlides = [
  {
    img: serviceBanner,
    alt: "Offer 1",
  },
];
function Contact() {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const [loading, setLoading] = useState(false);

  const pattern = /^[6-9][0-9]{6,9}$/;
  if (phone !== "" && phone.length === 10 && !pattern.test(phone)) {
    toast.error("Enter valid phone number", {
      theme: "colored",
    });
  }

  let navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    if (name !== "" && phone !== "") {
      const dataCollectionRef = collection(db, "enquiries");
      try {
        await addDoc(dataCollectionRef, {
          name: name,
          email: email,
          phone: phone,
          formType: "contact",
          timestamp: serverTimestamp(),
        });
        navigate("/thank-you");
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    }
  }

  return (
    <>
      <Helmet>
        <title>
          Contact now for Maruti Car, Nexa Car Sales, Feedback or Complaint in
          Hyderabad | Gem Motors
        </title>
        <meta
          name="title"
          content="Contact now for Maruti Car, Nexa Car Sales, Feedback or Complaint in Hyderabad | Gem Motors"
        />

        <meta
          name="description"
          content="Contact now nearest Gem Maruti showroom for any Maruti Suzuki,Nexa car enquiry. For queries about any of the Maruti & Nexa cars, feedback or complaints call now."
        />
      </Helmet>
      <Header />

      <div className="hidden md:block">
        <img
          src={require("../assets/banners-3/Banners.jpg")}
          className="w-full 
              h-[250px]
              sm:h-[320px]
              md:h-[550px]
              lg:h-[550px]
              xl:h-[550px]
              object-cover  object-center"
          alt="outlets"
        />
      </div>
      <CustomSlider
        slides={servicemobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />
      <div className="px-4 shadow sm:px-0">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Contact
        </p>
      </div>
      <div className="container px-5 py-16 mx-auto">
        <p className="text-2xl font-semibold text-red-500">Contact Us</p>
        <form onSubmit={handleSubmit} className="mt-5 space-y-3">
          <div className="grid gap-3 lg:grid-cols-2 sm:grid-cols-2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-red-500 focus:border-red-500"
                type="text"
                required
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-red-500 focus:border-red-500"
                type="text"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Phone <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full h-10 px-3 border rounded-md outline-none focus:ring-red-500 focus:border-red-500"
                type="text"
                maxLength="10"
                minLength="10"
                required
                value={phone}
                onChange={(e) =>
                  setPhone(
                    e.target.value.replace(/[^1-9 ]/g, "") &&
                      e.target.value.replace(/ /g, ""),
                  )
                }
              />
              {!pattern.test(phone) && phone.length === 10 ? (
                <small className="text-red-500">phone number is invalid</small>
              ) : (
                ""
              )}
            </div>
          </div>
          <p className="text-gray-700">
            <span className="font-bold text-black">Disclaimer</span>: I agree
            that by clicking the ‘Submit’ button below, I am explicitly
            soliciting a call / Message from Gem Motor Pvt. Ltd or its
            Representatives on my ‘Mobile’
          </p>
          <div className="flex items-start">
            <input
              id="disclaimer"
              name="disclaimer"
              type="checkbox"
              className="w-4 h-4 rounded"
            />
            <div className="ml-2 text-sm">
              <label htmlFor="disclaimer" className="font-medium text-gray-700">
                Please Agree with Following Disclaimer
              </label>
            </div>
          </div>
          <button
            className="hover:bg-[#1D3A8A] bg-red-500 duration-500 text-white rounded py-2.5 px-5"
            type="submit"
            disabled={pattern.test(phone) && phone.length === 10 ? false : true}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <CgSpinner className="w-5 h-5 mr-2 text-white animate-spin" />
                Loading
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
}

export default Contact;
